import { actionCreator } from '../helpers/actionCreator';
import { E_CASES_ACTION_TYPES } from './actionTypes';
export var casesActions = {
    resetCases: function () { return actionCreator(E_CASES_ACTION_TYPES.RESET_CASES); },
    resetCasesCollectionResult: function () { return actionCreator(E_CASES_ACTION_TYPES.RESET_CASES_COLLECTION_RESULT); },
    fetchCasesRequested: function () { return actionCreator(E_CASES_ACTION_TYPES.FETCH_CASES_REQUESTED); },
    fetchCasesSucceeded: function (payload) { return actionCreator(E_CASES_ACTION_TYPES.FETCH_CASES_SUCCEEDED, payload); },
    updateCasesCollectionLoading: function (isLoading) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CASES_COLLECTION_LOADING, { isLoading: isLoading });
    },
    fetchCurrentCaseDetailsRequested: function (caseToken) {
        return actionCreator(E_CASES_ACTION_TYPES.FETCH_CURRENT_CASE_DETAILS_REQUESTED, { caseToken: caseToken });
    },
    fetchCurrentCaseDetailsSucceeded: function (currentCase, hardData) {
        return actionCreator(E_CASES_ACTION_TYPES.FETCH_CURRENT_CASE_DETAILS_SUCCEEDED, { currentCase: currentCase, hardData: hardData });
    },
    fetchCurrentCaseDetailsCancelled: function () { return actionCreator(E_CASES_ACTION_TYPES.FETCH_CURRENT_CASE_DETAILS_CANCELLED); },
    saveAllQueries: function (allQueries) { return actionCreator(E_CASES_ACTION_TYPES.SAVE_ALL_QUERIES, { allQueries: allQueries }); },
    setDefaultFilter: function (filters) { return actionCreator(E_CASES_ACTION_TYPES.SET_DEFAULT_FILTER, { filters: filters }); },
    resetFilters: function () { return actionCreator(E_CASES_ACTION_TYPES.RESET_FILTERS); },
    updateSearchFilterRequested: function (filters) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_SEARCH_FILTERS_REQUESTED, { filters: filters });
    },
    updateSearchFilterSucceeded: function (filters) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_SEARCH_FILTERS_SUCCEEDED, { filters: filters });
    },
    saveAllColumns: function (allColumns) { return actionCreator(E_CASES_ACTION_TYPES.SAVE_ALL_COLUMNS, { allColumns: allColumns }); },
    updateColumnRequested: function (columns) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_COLUMN_REQUESTED, { columns: columns });
    },
    updateColumnSucceeded: function (columns) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_COLUMN_SUCCEEDED, { columns: columns });
    },
    updateDefaultColumnRequested: function (columns) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_DEFAULT_COLUMN_REQUESTED, { columns: columns });
    },
    updateDefaultColumnSucceeded: function (columns) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_DEFAULT_COLUMN_SUCCEEDED, { columns: columns });
    },
    updateTemplateRequested: function (template, caseToken) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_TEMPLATE_REQUESTED, { template: template, caseToken: caseToken });
    },
    updateTemplateSucceeded: function (template) { return actionCreator(E_CASES_ACTION_TYPES.UPDATE_TEMPLATE_SUCCEEDED, { template: template }); },
    updateCurrentCaseHistoryRequested: function (history) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_HISTORY_REQUESTED, { history: history });
    },
    updateCurrentCaseHistorySucceeded: function (history) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_HISTORY_SUCCEEDED, { history: history });
    },
    updateCurrentCaseCommentRequested: function (comment) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_COMMENT_REQUESTED, { comment: comment });
    },
    updateCurrentCaseCommentSucceeded: function (comments) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_COMMENT_SUCCEEDED, { comments: comments });
    },
    sendCommentRequested: function (product, productToken, comment) {
        return actionCreator(E_CASES_ACTION_TYPES.SEND_COMMENT_REQUESTED, { product: product, productToken: productToken, comment: comment });
    },
    exportCasesInCSVRequested: function () { return actionCreator(E_CASES_ACTION_TYPES.EXPORT_CASES_IN_CSV_REQUESTED); },
    updateCasesExportLoading: function (isLoading) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CASES_EXPORT_LOADING, { isLoading: isLoading });
    },
    updateHistoryFilters: function (historyFilters) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_HISTORY_FILTERS, { historyFilters: historyFilters });
    },
    updateCurrentApplicants: function (currentApplicantId) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_APPLICANT, { currentApplicantId: currentApplicantId });
    },
    clearCurrentCase: function () { return actionCreator(E_CASES_ACTION_TYPES.CLEAR_CURRENT_CASE); },
    resetHistoryFilters: function () { return actionCreator(E_CASES_ACTION_TYPES.RESET_HISTORY_FILTERS); },
    updateDocStatusRequested: function (product, productToken, document, status) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_DOC_STATUS_REQUESTED, {
            product: product,
            productToken: productToken,
            document: document,
            newStatus: status,
        });
    },
    updateDocStatusSucceeded: function () { return actionCreator(E_CASES_ACTION_TYPES.UPDATE_DOC_STATUS_SUCCEEDED); },
    updateDocStatusLoading: function (documents) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_DOC_STATUS_LOADING, { documents: documents });
    },
    makeCaseActionTaskRequested: function (decision) {
        return actionCreator(E_CASES_ACTION_TYPES.MAKE_CASE_ACTION_TASK_REQUESTED, { decision: decision });
    },
    makeCaseActionTaskCancelled: function () { return actionCreator(E_CASES_ACTION_TYPES.MAKE_CASE_ACTION_TASK_CANCELLED); },
    updateActionModal: function (actionModal) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_ACTION_MODAL, { actionModal: actionModal });
    },
    updateActionModalLoading: function (isLoading) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_ACTION_MODAL_LOADING, { isLoading: isLoading });
    },
    updateModalIncompleteParamsRequested: function (incompleteParams) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_MODAL_INCOMPLETE_PARAMS, { incompleteParams: incompleteParams });
    },
    resetModalCache: function () { return actionCreator(E_CASES_ACTION_TYPES.RESET_MODAL_CACHE); },
    updateModalCache: function (params) { return actionCreator(E_CASES_ACTION_TYPES.UPDATE_MODAL_CACHE, { params: params }); },
    confirmDecisionModalRequested: function (params) {
        return actionCreator(E_CASES_ACTION_TYPES.CONFIRM_DECISION_MODAL_REQUESTED, { params: params });
    },
    confirmDecisionModalSucceeded: function () { return actionCreator(E_CASES_ACTION_TYPES.CONFIRM_DECISION_MODAL_SUCCEEDED); },
    confirmDecisionModalCancelled: function () { return actionCreator(E_CASES_ACTION_TYPES.CONFIRM_DECISION_MODAL_CANCELLED); },
    fetchContractsRequested: function () { return actionCreator(E_CASES_ACTION_TYPES.FETCH_CONTRACTS_REQUESTED); },
    fetchContractsSucceeded: function (contracts) {
        return actionCreator(E_CASES_ACTION_TYPES.FETCH_CONTRACTS_SUCCEEDED, { contracts: contracts });
    },
    downloadContract: function (contract) { return actionCreator(E_CASES_ACTION_TYPES.DOWNLOAD_CONTRACT, { contract: contract }); },
    updateCurrentCaseLoading: function (isLoading) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_CURRENT_CASE_LOADING, { isLoading: isLoading });
    },
    updateIsNotificationsActivated: function (isNotificationsActivated) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_NOTIFICATION, { isNotificationsActivated: isNotificationsActivated });
    },
    downloadFileUrlRequested: function (fileUrl) {
        return actionCreator(E_CASES_ACTION_TYPES.DOWNLOAD_FILE_URL_REQUESTED, { fileUrl: fileUrl });
    },
    updateMrzLinesRequested: function (mrzLines) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_MRZ_LINES_REQUESTED, { mrzLines: mrzLines });
    },
    updateMrzLinesSucceeded: function (applicants) {
        return actionCreator(E_CASES_ACTION_TYPES.UPDATE_MRZ_LINES_SUCCEEDED, { applicants: applicants });
    },
    updateAutoPlay: function (autoPlay) { return actionCreator(E_CASES_ACTION_TYPES.UPDATE_AUTO_PLAY, { autoPlay: autoPlay }); },
    fetchAutoSearch: function () { return actionCreator(E_CASES_ACTION_TYPES.FETCH_AUTO_SEARCH_REQUESTED); },
    fetchAutoSearchSucceeded: function (payload) { return actionCreator(E_CASES_ACTION_TYPES.FETCH_AUTO_SEARCH_SUCCEEDED, payload); },
};
